import { gql } from "@apollo/client";

export const SEND_MESSAGE = gql`
  mutation SendMessage($message: message_adhoc_insert_input!) {
    insert_message_adhoc_one(object: $message) {
      id
    }
  }
`;
